import isFilledDatePopup from './isFilledDatePopup';
import isFilledSignPopup from './isFilledSignPopup';
import isFilledTextPopup from './isFilledTextPopup';

export default popup =>
  !!(isFilledDatePopup(popup) || isFilledSignPopup(popup) || isFilledTextPopup(popup));




// WEBPACK FOOTER //
// ./src-react/Popups/helpers/isFilledPopup.jsx